/**
 * cookie操作
 * 存储、读取、删除
 */
const Cookie = {
  /**
   * 保存cookie
   * @param name cookie名字
   * @param value 值
   * @param day 到期时间天数
   */
  set(name, value, day) {
    const expires = day ? new Date(Date.now() + day * 864e5).toUTCString() : '';
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; HttpOnly ; Secure ; path=/`;
  },
  /**
   * 获取cookie
   * @param name cookie名字
   */
  get(name) {
    const cookies = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));
    if (cookies !== null) {
      return decodeURIComponent(cookies[2]);
    } else {
      return null;
    }
  },
  /**
   * 删除cookie
   * @param name cookie名字
   */
  remove(name) {
    this.set(name, '', -1);
  }
};

export default Cookie;